import { isPresent } from 'utils/isPresent';
import React, { PureComponent } from 'react';
import withStyles from 'housecall-ui/dist/DesignSystem/Styles/withStyles';
import { connect } from 'react-redux';
import Grid from 'housecall-ui/dist/DesignSystem/Layout/Grid/Grid';
import { CUSTOMER_TYPE } from '../../Tags/TagsData';
import FormTextField from '../../Common/Form/FormTextField.js.jsx';
import TagsSectionContainer from '../../Tags/TagsSectionContainer.jsx';
import SearchCustomer from './SearchCustomers.jsx';
import LeadSourceField from './LeadSourceField';
import { getFormValues } from 'redux-form';
import {
  ADD_CUSTOMER_TAGS,
  CUSTOMER_INFO_FORM,
  DELETE_CUSTOMER_TAGS,
  UPDATE_BILLING_ADDRESS_INDEX,
  UPDATE_PARENT_CUSTOMER,
} from './Redux/Actions';
import CustomersApi from '../api/CustomersApi';
import SectionTitle from './SectionTitle';
import NoteIcon from 'housecall-ui/dist/IconsAndImages/Icons/Note';

const styles = (theme) => ({
  container: {
    paddingBottom: 30,
  },
  [theme.breakpoints.up('md')]: {
    billsToPosition: {
      position: 'relative',
      left: 77,
    },
  },
});

@connect(
  (state) => ({
    currentTags: state.addOrEditCustomer.customerTags,
    parentCustomer: state.addOrEditCustomer.parentCustomer,
    customerId: (getFormValues(CUSTOMER_INFO_FORM)(state) || {}).id,
  }),
  (dispatch) => ({
    addTag: (tag) => {
      dispatch({ type: ADD_CUSTOMER_TAGS, tag: tag });
    },
    deleteTag: (tag) => {
      dispatch({ type: DELETE_CUSTOMER_TAGS, tag: tag });
    },
    updateParentCustomer: (customer) => {
      if (isPresent(customer)) {
        dispatch({ type: UPDATE_BILLING_ADDRESS_INDEX, index: -1 });
      } else {
        dispatch({ type: UPDATE_BILLING_ADDRESS_INDEX, index: 0 });
      }
      dispatch({ type: UPDATE_PARENT_CUSTOMER, customer: customer });
    },
  })
)
@withStyles(styles)
export default class CustomerDetailsFormContent extends PureComponent {
  render() {
    const { parentCustomer, currentTags, classes } = this.props;
    let searchCustomerValue = '';

    if (isPresent(parentCustomer)) {
      if (isPresent(parentCustomer.display_name)) {
        searchCustomerValue = parentCustomer.display_name;
      } else {
        searchCustomerValue = parentCustomer.name || parentCustomer.company_or_name;
      }
    }

    return (
      <Grid container spacing={24} className={this.props.classes.container}>
        <Grid item xs={12}>
          <SectionTitle name="Notes" icon={<NoteIcon />} />
        </Grid>
        <Grid item xs={12} sm={6} md={8}>
          <FormTextField name="notes" label="Customer notes" multiline fullWidth={true} />
        </Grid>
        <Grid item xs={12} sm={6} md={3} className={classes.billsToPosition}>
          <SearchCustomer
            label="This customer bills to"
            onSelect={(customer) => {
              this.props.updateParentCustomer(customer);
            }}
            onSearch={(query) => {
              return CustomersApi.searchCustomer(query, this.props.customerId);
            }}
            value={searchCustomerValue}
            disabled={isPresent(parentCustomer)}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={8}>
          <TagsSectionContainer
            useLatestMaterialUI={true}
            currentTags={currentTags}
            tagType={CUSTOMER_TYPE}
            addTag={(tagType, tag) => {
              this.props.addTag(tag);
            }}
            deleteTag={(tagType, tag) => {
              this.props.deleteTag(tag);
            }}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={3} className={classes.billsToPosition}>
          <LeadSourceField />
        </Grid>
      </Grid>
    );
  }
}
